import { render, staticRenderFns } from "./CardWithHeader.vue?vue&type=template&id=5a4d46d6&scoped=true&"
import script from "./CardWithHeader.vue?vue&type=script&lang=js&"
export * from "./CardWithHeader.vue?vue&type=script&lang=js&"
import style0 from "./CardWithHeader.vue?vue&type=style&index=0&id=5a4d46d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d46d6",
  null
  
)

export default component.exports